module.exports = "mat-table[name=\"tablaGaleria\"] .mat-column-acciones {\n  max-width: 84px; }\n"